module.exports = __webpack_public_path__ + "static/img/7.1d649f63.png";